import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signin-login_modal-view';
/**
 * Event to track which signin screen was viewed
 */
export function trackSigninLoginModalView(View) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { View },
    });
}
